module.exports = __webpack_public_path__ + "static/media/confirm.02521605.svg";